<template>
  <div class="header">
    <b-container>
      <b-row align-v="center" class="header-wrapper">
        <b-col offset-md="1" md="3">
          <div class="back-home"><a href="https://www.franchise.org/">Back to Franchise.org</a></div>
        </b-col>
        <b-col md="4">
          <div class="logo-wrapper"><img class="logo loaded" :src="logoImage.src"></div>
        </b-col>
        <b-col md="4" sm="12">
          <div class="nav-wrapper">
            <div class="nav">
              <ul>
                <li>
                  <div class="circle" v-scroll-to="'#intro'">
                    <div class="circle-inner"></div>
                  </div>
                  <a class="nav-item" data-section="intro"></a>
                </li>
                <li>
                  <div class="circle" v-scroll-to="'#first'">
                    <div class="circle-inner"></div>
                  </div>
                <a class="nav-item" data-section="first"></a>
              </li>
                <li>
                  <div class="circle" v-scroll-to="'#second'">
                    <div class="circle-inner"></div>
                  </div>
                  <a class="nav-item" data-section="second"></a>
                </li>
                <li>
                  <div class="circle" v-scroll-to="'#third'">
                    <div class="circle-inner"></div>
                  </div>
                  <a class="nav-item" href="#third" data-section="third"></a>
                </li>
                <li>
                  <div class="circle" v-scroll-to="'#fourth'">
                    <div class="circle-inner"></div>
                  </div>
                  <a class="nav-item" data-section="fourth"></a>
                </li>
              </ul>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Header',
  methods: {
    watchScroll () {
      var isIE11 = !!window.MSInputMethodContext && !!document.documentMode
      var scrollDepth = window.scrollY
      if(isIE11) {
        scrollDepth = window.pageYOffset
      }
      if(scrollDepth > 50 && this.$el){
        this.$el.classList.add("shrink")
      } else {
        this.$el.classList.remove("shrink")
      }
    }
  },
  data() {
    return {
      logoImage: {
        src: '/2017-annual-report/static/images/logo.svg',
        loading: '/2017-annual-report/static/images/logo_loading.png',
      }
    }
  },
  mounted () {
    var _this = this
    this.$nextTick(function() {
      window.addEventListener('scroll', this.watchScroll)
    })
  },
  destroyed () {
    window.removeEventListener('scroll', this.watchScroll)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../global.scss";
#app .header {
  background: rgba(0,0,0,0.5);
  color: $white;
  position: relative;
  padding: 15px;
  transition: all 1s ease-in-out;
  -webkit-transition: all 1s ease-in-out;
  -moz-transition: all 1s ease-in-out;
  height: 125px;
  width: 100%;
  z-index: 15;
  top: 0;
  left: 0;
  position: fixed;
  text-align: center;
  @media all and (min-width: $md){
    height: 95px;
  }
  .back-home {
    left: 0;
    font-size: 10px;
    margin-bottom: 5px;
    text-align: center;
    line-height: 16px;
    @media all and (min-width: $md){
      font-size: 16px;
      margin-bottom: 0;
      text-align: left;
      line-height: 24px;
    }
  }
  .logo-wrapper {
    margin: 5px 0;
    @media all and (min-width: $md){
      margin: 0;
    }
    img {
      transition: all 1s ease-in-out;
      -webkit-transition: all 1s ease-in-out;
      -moz-transition: all 1s ease-in-out;
      width: auto;
      height: 40px;
      opacity: 0;
      @media all and (min-width: $md){
        height: 60px;
      }
      &[lazy=loading] {
        transition: opacity linear .4s 0s;
        opacity: 0;
        filter: blur(10px);
      }
      &[lazy=loaded],&[lazy=error], &.loaded {
        opacity: 1;
      }
    }
  }
  @media all and (min-width: $md){
    &.shrink {
      height: 75px;
      .logo-wrapper {
        img {
          height: 45px;
        }
      }
    }
  }

  a {
    color: white;
  }
  .nav-wrapper {
    width: 170px;
    text-align: center;
    margin: 0 auto;
    .nav {
      margin-top: 15px;
      width: 100%;
      position: relative;
      border-top: 2px solid white;
      ul {
        list-style-type: none;
        padding: 0;
        width: 100%;
        margin: 0;
        li {
          display: inline-block;
          margin: 0;
          float: left;
          padding: 0;
          padding-right: calc((170px/ 4) - 13px);
          @media all and (min-width: $md){
            padding-right: calc((170px/ 4) - 19px);
          }
          &:last-child {
            padding-right: 0;
            float: right;
          }
          .circle {
            border-radius: 50%;
            width: 10px;
            height: 10px;
            top: -6px;
            @media all and (min-width: $md){
              width: 15px;
              height: 15px;
              top: -9px;
            }
            position: relative;
            background: $mid_gray;
            cursor: pointer;
            transition: all 0.5s ease-in-out;
            -webkit-transition: all 0.5s ease-in-out;
            -moz-transition: all 0.5s ease-in-out;
          }
          &.active .circle {
            background: white;
          }
          a {
            text-indent: 100%;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/components/Header.vue